const walkForce = 6;
export default function Move(scene, level) {
  const {
    player
  } = level;
  function move(active) {
    if (active) player.velocity.x = walkForce;
  }
  return move;
}